import { render, staticRenderFns } from "./MoveAllChicksToCorralModal.vue?vue&type=template&id=5eb85838&scoped=true"
import script from "./MoveAllChicksToCorralModal.vue?vue&type=script&lang=js"
export * from "./MoveAllChicksToCorralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb85838",
  null
  
)

export default component.exports